module.exports = "<div class=\"partner-smallFormat\" wow-scrollbar wow-hide-scroll>\r\n    <div class=\"partner-smallFormat-content u-xsContentHeight\">\r\n        <oly-dynamic-content class=\"dynamic-content2-panelTop\" oly-dc-url-schedule></oly-dynamic-content>\r\n        <ng-transclude></ng-transclude>\r\n        <oly-dynamic-content class=\"dynamic-content2-panelBottom\" oly-dc-url-schedule=\"bottom\"></oly-dynamic-content>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shop/partner/partner-smallformat.directive.html
// module id = 216
// module chunks = 0 2